const checkboxs = document.querySelectorAll("input[type=checkbox]");
checkboxs.forEach((el) => {
  el.addEventListener('change', function (c) {
    c.target.parentNode.classList.toggle('active');
  });
});
